import './index.css';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { s as styles } from './base-text-DqfkG6Rh.js';

const BaseText = ({ Element = 'div', style, typography, children, maxLines, ...props }) => {
    const textStyles = classNames(styles.text, maxLines && styles.textMaxLines, styles[`text_style-${style}`], styles[`text_typography-${typography}`]);
    return (jsx(Element, { ...props, className: textStyles, style: { WebkitLineClamp: maxLines }, children: children }));
};

export { BaseText };
//# sourceMappingURL=BaseText.js.map
